import { useEffect, useState } from "react";
import { getHero, getHome } from "../../services/api";
import { useNavigate } from "react-router-dom";
import { SharedHeader, SharedFooter } from "../../components/site/SharedLayout";
import { CMS_BASE_URL, SITE_BASE_URL } from "../../config";
import PageLoader from "../../components/site/PageLoader";
import SEO from "../../components/SEO";

const GLSPharma = () => {
  const navigate = useNavigate();
  const [slide, setSlide] = useState(0);
  const [heroData, setHeroData] = useState(null);
  const [homeData, setHomeData] = useState(null);
  const [loading, setLoading] = useState(true);
const heroSlides = heroData?.slides || [];
const current = heroSlides[slide] || {};
const stats = homeData?.statistics;
const about = homeData?.about;
const missionVision = homeData?.mission_vision;
const parentCompany = homeData?.parent_company;
const productPortfolio = homeData?.product_portfolio;
const manufacturing = homeData?.manufacturing;
const globalReach = homeData?.global_reach;
const partnerCTA = homeData?.partner_cta;
const seo = homeData?.seo || {};
const convertCmsUrl = (url) => {
  if (!url) return "/";

  // Handle section links
  if (url.includes("#")) {
    return url.substring(url.indexOf("#"));
  }

  return url
    .replace(CMS_BASE_URL, "")
    .replace(SITE_BASE_URL, "")
    .replace("/contact-us", "/contact")
    .replace(/\/$/, "");
};
  /* ── Hero auto-rotate every 5s. Pauses briefly after manual nav
        so the user's click isn't immediately overridden. ── */
  const [pauseUntil, setPauseUntil] = useState(0);
  useEffect(() => {
    const id = setInterval(() => {
      if (Date.now() < pauseUntil) return;
      if (heroSlides.length > 0) {
    setSlide((s) => (s + 1) % heroSlides.length);
}
    }, 5000);
    return () => clearInterval(id);
  }, [pauseUntil, heroSlides.length]);

  const goPrev = () => {
    setSlide((s) => (s - 1 + heroSlides.length) % heroSlides.length);
    setPauseUntil(Date.now() + 8000);
  };
  const goNext = () => {
    setSlide((s) => (s + 1) % heroSlides.length);
    setPauseUntil(Date.now() + 8000);
  };

  
  useEffect(() => {
  async function loadData() {
  try {
    const [hero, home] = await Promise.all([
      getHero(),
      getHome(),
    ]);

    setHeroData(hero);
    setHomeData(home);
  } catch (err) {
    console.error(err);
  } finally {
    setLoading(false);
  }
}

  loadData();
}, []);

useEffect(() => {
  setSlide(0);
}, [heroSlides.length]);
if (loading) {
  return <PageLoader />;
}
console.log(homeData);
console.log(homeData?.seo);
  return (
    <>
    <SEO
  title={seo.title}
  description={seo.description}
  canonical={seo.canonical}
  robots={seo.robots || "index, follow"}
  keywords={seo.keywords}
  ogDescription={seo.og_description}
  ogImage={seo.og_image}
  twitterTitle={seo.twitter_title}
  twitterDescription={seo.twitter_description}
  twitterImage={seo.twitter_image}
  author="GLS Pharma"
  publisher="GLS Pharma"
/>
    
    <div
      style={{
        fontFamily: "'Inter', 'Segoe UI', Arial, sans-serif",
        margin: 0,
        padding: 0,
        color: "#222",
        overflowX: "hidden",
      }}
    >
      <SharedHeader />

      {/* ══════════════════════════════════════════
          HERO SLIDER — 3 panels, auto-rotate, arrow nav with video background
      ══════════════════════════════════════════ */}
      <section
        className="home-hero"
        style={{
          display: "flex",
          alignItems: "center",
          minHeight: "760px",
          padding: "60px var(--pad-x) 140px",
          position: "relative",
          overflow: "hidden",
        }}
      >
        {/* Video Background */}
        <video
          autoPlay
          loop
          muted
          playsInline
          style={{
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            objectFit: "cover",
            zIndex: 1,
          }}
        >
          <source
    src={current.background_video}
    type="video/mp4"
/>
          {/* Fallback to image if video fails to load */}
          <img
    src={current.background_image}
    alt="Hero Background"
    style={{
      width: "100%",
      height: "100%",
      objectFit: "cover",
    }}
/>
        </video>
        
        {/* Badge - Right Side */}
        <div
          style={{
            position: "absolute",
            top: "30px",
            right: "40px",
            zIndex: 3,
            pointerEvents: "none",
          }}
          className="hero-badge-wrapper"
        >
          {heroData?.badge?.image?.url && (
            <img
              src={heroData.badge.image.url}
              alt={heroData.badge.image.alt || "GLS Pharma"}
              className="hero-logo"
              style={{
                width: "clamp(70px, 15vw, 190px)",
                height: "clamp(70px, 15vw, 190px)",
                objectFit: "cover",
                objectPosition: "center",
                borderRadius: "50%",
                opacity: 0,
                animation: "slowLogoReveal 0.8s ease-out forwards, logoPop 2.2s ease-in-out 0.8s infinite",
                filter: "drop-shadow(0 8px 24px rgba(0, 0, 0, 0.3))",
              }}
            />
          )}
        </div>
        {/* SLIDE CONTENT — keyed on `slide` so it re-mounts & re-animates */}
        <div
          key={slide}
          style={{
            position: "relative",
            zIndex: 3,
            maxWidth: 600,
            paddingBottom: 40,
            animation: "heroFadeIn 0.6s ease",
          }}
        >
          <h1
            style={{
              color: "#fff",
              fontSize: 72,
              fontWeight: 800,
              margin: 0,
              lineHeight: 1.1,
            }}
          >
            {current.heading}
  <br />
  <span style={{ color: "#B16116" }}>
    {current.highlight}
  </span>
  <br />
  <span>{current.bottom_title}</span>
          </h1>
          <p
            style={{
              color: "rgba(255,255,255,0.82)",
              fontSize: 18,
              margin: "22px 0 32px",
              maxWidth: 520,
              lineHeight: 1.65,
            }}
          >
            {current.subtitle}
          </p>
          <button
  onClick={() => {
  const link = convertCmsUrl(current.button_link);

  if (link.startsWith("#")) {
    const element = document.querySelector(link);

    if (element) {
      element.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });

      // Update the URL without reloading
      window.history.replaceState(null, "", link);
      // or: window.location.hash = link;
    }
  } else {
    navigate(link);
  }
}}
  style={{
    background: "#B16116",
    color: "#fff",
    border: "none",
    borderRadius: 8,
    padding: "14px 32px",
    fontWeight: 700,
    fontSize: 16,
    cursor: "pointer",
    boxShadow: "0 4px 20px rgba(224,123,42,0.4)",
  }}
>
  {current.button_text}
</button>
        </div>

        {/* Navigation Arrows */}
        <button
          onClick={goPrev}
          aria-label="Previous slide"
          style={{
            position: "absolute",
            left: 20,
            top: "50%",
            transform: "translateY(-50%)",
            zIndex: 4,
            background: "rgba(255,255,255,0.2)",
            border: "none",
            borderRadius: "50%",
            width: 48,
            height: 48,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            cursor: "pointer",
            color: "#fff",
            fontSize: 18,
            fontWeight: 700,
            transition: "all 0.3s ease",
          }}
          onMouseEnter={(e) => {
            e.target.style.background = "rgba(255,255,255,0.3)";
          }}
          onMouseLeave={(e) => {
            e.target.style.background = "rgba(255,255,255,0.2)";
          }}
        >
          ‹
        </button>
        
        <button
          onClick={goNext}
          aria-label="Next slide"
          style={{
            position: "absolute",
            right: 20,
            top: "50%",
            transform: "translateY(-50%)",
            zIndex: 4,
            background: "rgba(255,255,255,0.2)",
            border: "none",
            borderRadius: "50%",
            width: 48,
            height: 48,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            cursor: "pointer",
            color: "#fff",
            fontSize: 18,
            fontWeight: 700,
            transition: "all 0.3s ease",
          }}
          onMouseEnter={(e) => {
            e.target.style.background = "rgba(255,255,255,0.3)";
          }}
          onMouseLeave={(e) => {
            e.target.style.background = "rgba(255,255,255,0.2)";
          }}
        >
          ›
        </button>

        {/* Inline keyframes for the fade-in (scoped to hero) */}
        <style>{`
          @keyframes heroFadeIn {
            0% { opacity: 0; transform: translateY(10px); }
            100% { opacity: 1; transform: translateY(0); }
          }
          @keyframes slowLogoReveal {
            0% {
              opacity: 0;
              transform: scale(0.2) translateX(50px);
            }
            20% {
              opacity: 0.3;
              transform: scale(0.5) translateX(30px);
            }
            40% {
              opacity: 0.6;
              transform: scale(0.8) translateX(15px);
            }
            70% {
              opacity: 0.9;
              transform: scale(1.05) translateX(0px);
            }
            90% {
              opacity: 1;
              transform: scale(1.02) translateX(0px);
            }
            100% {
              opacity: 1;
              transform: scale(1) translateX(0px);
            }
          }

          /* Repeating subtle pop to keep the logo 'popping' periodically */
          @keyframes logoPop {
            0% { transform: scale(1) translateX(0); }
            18% { transform: scale(1.06) translateX(-2px); }
            36% { transform: scale(0.98) translateX(0); }
            58% { transform: scale(1.03) translateX(-1px); }
            80% { transform: scale(1.01) translateX(0); }
            100% { transform: scale(1) translateX(0); }
          }

          @media (max-width: 768px) {
            .hero-badge-wrapper {
              top: 12px !important;
              bottom: auto !important;
              right: 12px !important;
              transform: none !important;
            }
            .hero-badge-wrapper img.hero-logo {
              width: 70px !important;
              height: 70px !important;
            }
          }
        `}</style>

        {/* Stats bar — stays FIXED across all slides */}
        <div
          className="stats-bar"
          style={{
            position: "absolute",
            bottom: 0,
            left: 0,
            right: 0,
            background: "#0b2a5b",
            display: "flex",
            justifyContent: "space-around",
            alignItems: "center",
            padding: "18px 40px",
            zIndex: 4,
          }}
        >
          {[
            stats?.years,
            stats?.countries,
            stats?.certification,
            stats?.achievement,
          ].map((s, i) => (
            <div
              key={i}
              style={{
                textAlign: "center",
                flex: 1,
                borderRight:
                  i < 3 ? "1px solid rgba(255,255,255,0.15)" : "none",
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
              }}
            >
              {s?.isTextOnly ? (
                <div
                  style={{
                    color: "#ffffff",
                    fontSize: 13,
                    fontWeight: 600,
                    lineHeight: 1.5,
                    letterSpacing: 0.6,
                    textTransform: "uppercase",
                    padding: "0 12px",
                  }}
                >
                  {s?.label}
                </div>
              ) : (
                <>
                  <div
                    style={{
                      color: "#ffffff",
                      fontWeight: 400,
                      fontSize: 28,
                      letterSpacing: 0.5,
                    }}
                  >
                    {s?.number}
                  </div>

                  <div
                    style={{
                      color: "rgba(255,255,255,0.75)",
                      fontSize: 11,
                      marginTop: 6,
                      letterSpacing: 1,
                      textTransform: "uppercase",
                      whiteSpace: "normal",
                    }}
                  >
                    {s?.label}
                  </div>
                </>
              )}
            </div>
          ))}
        </div>
      </section>

      {/* Stats bar as separate section on mobile */}
      <section 
        className="stats-bar-mobile"
        style={{
          background: "#0b2a5b",
          display: "none", // Hidden by default, shown on mobile via CSS
          padding: "16px var(--pad-x-sm, 20px)",
        }}
      >
        <div
          style={{
            display: "flex",
            justifyContent: "space-around",
            alignItems: "center",
            gap: 8,
          }}
        >
          {[
            stats?.years,
            stats?.countries,
            stats?.certification,
            stats?.achievement,
          ].map((s, i) => (
            <div
              key={i}
              style={{
                flex: 1,
                textAlign: "center",
                padding: "8px 4px",
                borderRight: i < 3 ? "1px solid rgba(255,255,255,0.15)" : "none",
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
              }}
            >
              <div
                style={{
                  color: "#ffffff",
                  fontWeight: 400,
                  fontSize: 16,
                  letterSpacing: 0.5,
                  marginBottom: 2,
                }}
              >
                {s?.number}
              </div>
              <div
                style={{
                  color: "rgba(255,255,255,0.75)",
                  fontSize: 8,
                  letterSpacing: 0.8,
                  textTransform: "uppercase",
                  whiteSpace: "normal",
                  lineHeight: 1.5,
                }}
              >
                {s?.label}
              </div>
            </div>
          ))}
        </div>
      </section>

      {/* ABOUT SECTION */}
      <section id="about" style={{ padding: "90px var(--pad-x)", background: "rgba(255,255,255,0.75)" }}>
        <div className="home-about-row" style={{ display: "flex", gap: 70, alignItems: "center" }}>
          {/* LEFT TEXT */}
          <div style={{ flex: 1 }}>
            {/* Eyebrow */}
            <div
              style={{
                color: "#B16116",
                fontWeight: 700,
                fontSize: 13,
                letterSpacing: 2.5,
                textTransform: "uppercase",
                marginBottom: 18,
              }}
            >
              {about?.small_title}
            </div>

            {/* Heading */}
            <h2
              style={{
                fontSize: 60,
                fontWeight: 800,
                color: "#1a3c6e",
                margin: "0 0 28px",
                lineHeight: 1.1,
              }}
            >
              {about?.title}
            </h2>

            {/* Paragraph 1 */}
            <p style={{ fontSize: 18, lineHeight: 1.8, color: "#555", marginBottom: 20 }}>
              {about?.description_1}
            </p>

            {/* Paragraph 2 */}
            <p style={{ fontSize: 18, lineHeight: 1.8, color: "#555", marginBottom: 32 }}>
              {about?.description_2}
            </p>

            {/* Pill Tags
            <div style={{ display: "flex", gap: 14, flexWrap: "wrap" }}>
              {["17+ Years", "30+ Countries", "WHO-GMP", "Aurobindo Group"].map(
                (tag, i) => (
                  <div
                    key={i}
                    style={{
                      background: "#eef2f8",
                      color: "#1a3c6e",
                      padding: "12px 24px",
                      borderRadius: 10,
                      fontWeight: 700,
                      fontSize: 14,
                      letterSpacing: 0.3,
                    }}
                  >
                    {tag}
                  </div>
                )
              )}
            </div> */}
          </div>

          {/* RIGHT IMAGE */}
          <div className="home-about-image" style={{ flex: 1 }}>
            <img
              src={about?.image?.url}
              alt="GLS Pharma Facility"
              style={{
                width: "100%",
                height: 420,
                objectFit: "cover",
                borderRadius: 20,
                boxShadow: "0 20px 50px rgba(0,0,0,0.1)",
              }}
            />
          </div>
        </div>
      </section>
      {/* MISSION & VISION */}
      <section
        style={{
          background: "#fffff",
          padding: "90px 0 100px",
        }}
      >
        {/* Header */}
        <div
          style={{
            textAlign: "center",
            marginBottom: 50,
            padding: "0 var(--pad-x)",
          }}
        >
          <div
            style={{
              color: "#B16116",
              fontWeight: 700,
              fontSize: 13,
              letterSpacing: 2.5,
              textTransform: "uppercase",
              marginBottom: 14,
            }}
          >
            Our Purpose
          </div>

          <h2
            className="mvv-title"
            style={{
              fontSize: 60,
              fontWeight: 800,
              color: "#1a3c6e",
              margin: 0,
              lineHeight: 1.2,
            }}
          >
            Mission, Vision &amp; Values
          </h2>
        </div>

        {/* Cards */}
        <div
          className="mvv-grid"
          style={{
            maxWidth: 1280,
            margin: "0 auto",
            padding: "0 24px",
            display: "grid",
            gridTemplateColumns: "1fr 1fr",
            gap: 34,
          }}
        >
          {/* ================= MISSION ================= */}
          <div
            className="mvv-box"
            style={{
              background: "#fff",
              borderRadius: 22,
              padding: "36px",
              border: "1px solid #e6edf7",
              boxShadow: "0 10px 30px rgba(0,0,0,.06)",
            }}
          >
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: 14,
                marginBottom: 28,
              }}
            >
              <span
                style={{
                  color: "#B16116",
                  fontSize: 24,
                }}
              >
                ★
              </span>

              <h3
                style={{
                  margin: 0,
                  color: "#B16116",
                  fontSize: 14,
                  letterSpacing: 3,
                  fontWeight: 800,
                  textTransform: "uppercase",
                }}
              >
                {missionVision?.mission?.title}
              </h3>
            </div>

            <div
              style={{
                background: "#f8f9fc",
                border: "1px solid #edf1f7",
                borderRadius: 16,
                padding: "28px",
              }}
            >
              <p
                style={{
                  margin: 0,
                  color: "#5b6175",
                  fontSize: 18,
                  lineHeight: 1.8,
                }}
              >
                {missionVision?.mission?.description}
              </p>
            </div>
          </div>

          {/* ================= VISION ================= */}
          <div
            className="mvv-box"
            style={{
              background: "#fff",
              borderRadius: 22,
              padding: "36px",
              border: "1px solid #e6edf7",
              boxShadow: "0 10px 30px rgba(0,0,0,.06)",
            }}
          >
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: 14,
                marginBottom: 28,
              }}
            >
              <span
                style={{
                  color: "#B16116",
                  fontSize: 24,
                }}
              >
                ★
              </span>

              <h3
                style={{
                  margin: 0,
                  color: "#B16116",
                  fontSize: 14,
                  letterSpacing: 3,
                  fontWeight: 800,
                  textTransform: "uppercase",
                }}
              >
                {missionVision?.vision?.title}
              </h3>
            </div>

            <div
              style={{
                background: "#f8f9fc",
                border: "1px solid #edf1f7",
                borderRadius: 16,
                padding: "28px",
              }}
            >
              <p
                style={{
                  margin: 0,
                  color: "#5b6175",
                  fontSize: 18,
                  lineHeight: 1.8,
                }}
              >
                {missionVision?.vision?.description}
              </p>
            </div>
          </div>
        </div>

        <style>{`
          .mvv-box{
            transition:all .3s ease;
          }

          .mvv-box:hover{
            transform:translateY(-6px);
          }

          @media (max-width:992px){

            .mvv-grid{
              grid-template-columns:1fr !important;
            }

            .mvv-box{
              padding:28px !important;
            }

          }

          @media (max-width:768px){

            .mvv-box h3{
              font-size:13px !important;
            }

            .mvv-box p{
              font-size:16px !important;
            }

          }
        `}</style>
      </section>

      {/* STRENGTH OF THE GROUP */}
      <section
        className="strength-row"
        style={{
          background: "linear-gradient(120deg, #0a1f4e 0%, #1a3c8e 100%)",
          padding: "60px var(--pad-x)",
          display: "flex",
          gap: 60,
          alignItems: "center",
        }}
      >
        <div style={{ flex: 1 }}>
          <div
            style={{
              color: "rgb(220 114 18)",
              fontSize: 16,
              letterSpacing: 2,
              textTransform: "uppercase",
              marginBottom: 8,
              fontWeight: 700,
            }}
          >
            {parentCompany?.small_title}
          </div>
          <h2
            style={{
              color: "#fff",
              fontSize: 60,
              fontWeight: 800,
              margin: 0,
              lineHeight: 1.2,
            }}
          >
            {parentCompany?.title}
          </h2>
          <p
            style={{
              color: "rgba(255,255,255,0.75)",
              fontSize: 18,
              marginTop: 16,
              maxWidth: 400,
              lineHeight: 1.7,
            }}
          >
            {parentCompany?.description}
          </p>
        </div>
        <div
          className="strength-stats"
          style={{
            display: "flex",
            gap: 24,
            flex: 1,
            justifyContent: "flex-end",
          }}
        >
          {parentCompany?.stats?.map((s, i) => (
  <div
    key={i}
    style={{
      background: "rgba(255,255,255,0.1)",
      borderRadius: 12,
      padding: "22px 20px",
      textAlign: "center",
      minWidth: 100,
      border: "1px solid rgba(255,255,255,0.15)",
    }}
  >
    <div
      style={{
        color: "#ffffff",
        fontWeight: 400,
        fontSize: 22,
      }}
    >
      {s.number}
    </div>

    <div
      style={{
        color: "rgba(255,255,255,0.7)",
        fontSize: 11,
        marginTop: 4,
        lineHeight: 1.4,
      }}
    >
      {s.label}
    </div>
  </div>
))}
        </div>
      </section>

      {/* PRODUCT PORTFOLIO */}
      <section id="portfolio" style={{ padding: "70px 80px", background: "#fff" }}>
        {/* HEADER */}
        <div
          className="product-portfolio-header"
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            marginBottom: 40,
          }}
        >
          <div>
            <div
              style={{
                color: "#B16116",
                fontWeight: 700,
                fontSize: 13,
                letterSpacing: 2,
                textTransform: "uppercase",
                marginBottom: 8,
              }}
            >
              {productPortfolio?.small_title}
            </div>

            <h2
              style={{
                fontSize: 36,
                fontWeight: 800,
                color: "#1a3c6e",
                margin: 0,
                maxWidth: 700,
              }}
            >
              {productPortfolio?.title}
            </h2>
          </div>

          <button
  onClick={() =>
    navigate(convertCmsUrl(productPortfolio?.button?.link))
  }
            style={{
              background: "transparent",
              border: "2px solid #1a3c6e",
              color: "#1a3c6e",
              borderRadius: 8,
              padding: "10px 22px",
              fontWeight: 600,
              fontSize: 14,
              cursor: "pointer",
            }}
          >
            {productPortfolio?.button?.text}
          </button>
        </div>

        {/* GRID (2x2) */}
        <div
          className="product-portfolio-grid"
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(2, 1fr)",
            gap: 20,
          }}
        >
          {productPortfolio?.products?.map((card, i) => (
            <div
              key={i}
              style={{
                background: "#f8faff",
                borderRadius: 12,
                padding: "20px 18px",
                border: "1px solid #e5ecf9",
                boxShadow: "0 4px 20px rgba(26,60,110,0.06)",
                transition: "all 0.3s ease",
                cursor: "pointer",
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = "translateY(-4px)";
                e.currentTarget.style.boxShadow =
                  "0 8px 25px rgba(26,60,110,0.12)";
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = "translateY(0)";
                e.currentTarget.style.boxShadow =
                  "0 4px 20px rgba(26,60,110,0.06)";
              }}
            >
              <div
                style={{
                  fontWeight: 700,
                  color: "#1a3c6e",
                  fontSize: 16,
                  marginBottom: 8,
                }}
              >
                {card.title}
              </div>

              <div
                style={{
                  color: "#556",
                  fontSize: 13,
                  lineHeight: 1.6,
                }}
              >
                {card.description}
              </div>
            </div>
          ))}
        </div>
      </section>

      {/* MANUFACTURING EXCELLENCE */}
      <section id="facility" style={{ background: "#fffff", padding: "90px 80px" }}>
        <div className="mfg-row" style={{ display: "flex", gap: 70, alignItems: "center" }}>
          <div className="mfg-image" style={{ flex: 1, position: "relative" }}>
            <img
              src={manufacturing?.image?.url}
              alt="Manufacturing Facility"
              style={{
                width: "100%",
                height: 360,
                objectFit: "cover",
                borderRadius: 24,
                boxShadow: "0 20px 50px rgba(0,0,0,0.1)",
              }}
            />

            <div
              style={{
                position: "absolute",
                top: 20,
                right: -20,
                background: "#1a4b8c",
                color: "#fff",
                padding: "18px 20px",
                borderRadius: 16,
                textAlign: "center",
                fontWeight: 700,
                boxShadow: "0 10px 30px rgba(0,0,0,0.15)",
              }}
            >
              <div style={{ fontSize: 28, fontWeight: 400 }}>{manufacturing?.capacity?.number}</div>
              <div style={{ fontSize: 11, letterSpacing: 1 }}>
                {manufacturing?.capacity?.label}
              </div>
            </div>
          </div>

          <div style={{ flex: 1 }}>
            <div
              style={{
                color: "#B16116",
                fontWeight: 700,
                fontSize: 13,
                letterSpacing: 2,
                textTransform: "uppercase",
                marginBottom: 10,
              }}
            >
              {manufacturing?.small_title}
            </div>

          <h2
              style={{
                fontSize: 36,
                fontWeight: 800,
                color: "#1a3c6e",
                marginBottom: 16,
              }}
            >
              {manufacturing?.title}
            </h2>

            <p
              style={{
                color: "#556",
                fontSize: 18,
                lineHeight: 1.8,
                marginBottom: 30,
              }}
            >
              {manufacturing?.description}
            </p>

            {manufacturing?.features?.map((item, i) => (
              <div
                key={i}
                style={{
                  display: "flex",
                  gap: 16,
                  alignItems: "flex-start",
                  background: "#fff",
                  padding: "18px 20px",
                  borderRadius: 14,
                  marginBottom: 16,
                  border: "1px solid #e6edf7",
                  boxShadow: "0 4px 14px rgba(0,0,0,0.04)",
                }}
              >
                <div>
                  <div
                    style={{
                      fontWeight: 700,
                      color: "#1a3c6e",
                      fontSize: 15,
                      marginBottom: 4,
                    }}
                  >
                    {item.title}
                  </div>
                  <div
                    style={{
                      color: "#667",
                      fontSize: 13,
                      lineHeight: 1.6,
                    }}
                  >
                    {item.description}
                  </div>
                </div>
              </div>
            ))}
            <button
              onClick={() =>
  navigate(convertCmsUrl(manufacturing?.button?.link))
}
              style={{
                background: "transparent",
                border: "2px solid #1a3c6e",
                color: "#1a3c6e",
                borderRadius: 8,
                padding: "10px 22px",
                fontWeight: 600,
                fontSize: 14,
                cursor: "pointer",
                marginTop: 10,
              }}
              onMouseEnter={(e) => {
                e.target.style.background = "#1a3c6e";
                e.target.style.color = "#fff";
              }}
              onMouseLeave={(e) => {
                e.target.style.background = "transparent";
                e.target.style.color = "#1a3c6e";
              }}
            >
              {manufacturing?.button?.text}
            </button>
          </div>
        </div>
      </section>

      {/* GLOBAL REACH */}
      <section className="reach-section" style={{ background: "#f5f7fb", padding: "80px 80px" }}>
        <div style={{ marginBottom: 40 }}>
          <h2
            style={{
              color: "#1a3c6e",
              fontSize: 36,
              fontWeight: 700,
              marginBottom: 10,
              lineHeight: "40px",
            }}
          >
            {globalReach?.title}
          </h2>

          <p
            style={{
              color: "#556",
              fontSize: 18,
            }}
          >
            {globalReach?.description}
          </p>
        </div>

        {/* TWO MAPS SIDE-BY-SIDE */}
        <div className="reach-grid" style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 30 }}>
          {/* LEFT — India map */}
          <div
            className="reach-map"
            style={{
              background: "#fff",
              borderRadius: 24,
              padding: "28px",
              boxShadow: "0 10px 30px rgba(0,0,0,0.06)",
              border: "1px solid #e6edf7",
            }}
          >
            <div
              style={{
                color: "#B16116",
                fontWeight: 700,
                fontSize: 12,
                letterSpacing: 2,
                textTransform: "uppercase",
                marginBottom: 8,
              }}
            >
              {globalReach?.maps?.india?.title}
            </div>
            <h3
              style={{
                color: "#1a3c6e",
                fontSize: 20,
                fontWeight: 700,
                margin: "0 0 18px",
                lineHeight: "28px",
              }}
            >
              {globalReach?.maps?.india?.subtitle}
            </h3>
            <img
              src={globalReach?.maps?.india?.image?.url}
              alt="India Presence"
              style={{
                width: "100%",
                height: 360,
                objectFit: "contain",
                borderRadius: 16,
              }}
            />
          </div>

          {/* RIGHT — World map */}
          <div
            className="reach-map"
            style={{
              background: "#fff",
              borderRadius: 24,
              padding: "28px",
              boxShadow: "0 10px 30px rgba(0,0,0,0.06)",
              border: "1px solid #e6edf7",
            }}
          >
            <div
              style={{
                color: "#B16116",
                fontWeight: 700,
                fontSize: 12,
                letterSpacing: 2,
                textTransform: "uppercase",
                marginBottom: 8,
              }}
            >
              {globalReach?.maps?.world?.title}
            </div>
            <h3
              style={{
                color: "#1a3c6e",
                fontSize: 20,
                fontWeight: 700,
                margin: "0 0 18px",
                lineHeight: "28px",
              }}
            >
              {globalReach?.maps?.world?.subtitle}
            </h3>
            <img
              src={globalReach?.maps?.world?.image?.url}
              alt="Global Reach"
              style={{
                width: "100%",
                height: 360,
                objectFit: "contain",
                borderRadius: 16,
              }}
            />
          </div>
        </div>

        {/* 3 STATS ACROSS FULL WIDTH */}
        <div
  className="reach-stats"
  style={{
    display: "grid",
    gridTemplateColumns: "repeat(3,1fr)",
    gap: 20,
    marginTop: 30,
  }}
>
  {globalReach?.stats?.map((item, i) => (
    <div
      key={i}
      style={{
        background: i === 0 ? "#1a3c6e" : "#fff",
        color: i === 0 ? "#fff" : "#1a3c6e",
        borderRadius: 20,
        padding: "26px 30px",
        boxShadow: "0 10px 30px rgba(0,0,0,.06)",
        border: i === 0 ? "none" : "1px solid #e6edf7",
      }}
    >
      <div
        style={{
          fontSize: 38,
          fontWeight: 400,
          color:
            i === 0
              ? "#fff"
              : i === 1
              ? "#B16116"
              : "#1a3c6e",
        }}
      >
        {item.number}
      </div>

      <div
        style={{
          fontSize: 13,
          marginTop: 6,
          color: i === 0 ? "rgba(255,255,255,.8)" : "#667",
          letterSpacing: .6,
        }}
      >
        {item.label}
      </div>
    </div>
  ))}
</div>

        {/* 4 FEATURE PILLS WITH LUCIDE-STYLE ICONS */}
        <div
          className="reach-features"
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(4, 1fr)",
            gap: 18,
            marginTop: 40,
            paddingTop: 30,
            borderTop: "1px solid #e6edf7",
          }}
        >
          {[
            {
              title: globalReach?.features?.[0]?.title,
              icon: (
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <path d="M22 8.35V20a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V8.35A2 2 0 0 1 3.26 6.5l8-3.2a2 2 0 0 1 1.48 0l8 3.2A2 2 0 0 1 22 8.35Z" />
                  <path d="M6 18h12" />
                  <path d="M6 14h12" />
                  <rect width="12" height="12" x="6" y="10" />
                </svg>
              ),
            },
            {
              title: globalReach?.features?.[1]?.title,
              icon: (
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <path d="M2 12h20" />
                  <path d="M12 2v20" />
                  <path d="m4.93 4.93 14.14 14.14" />
                  <path d="m19.07 4.93-14.14 14.14" />
                  <path d="M12 6 9 3" />
                  <path d="m12 6 3-3" />
                  <path d="M12 18l-3 3" />
                  <path d="m12 18 3 3" />
                  <path d="M6 12 3 9" />
                  <path d="m6 12-3 3" />
                  <path d="M18 12l3-3" />
                  <path d="m18 12 3 3" />
                </svg>
              ),
            },
            {
              title: globalReach?.features?.[2]?.title,
              icon: (
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <path d="M14 18V6a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v11a1 1 0 0 0 1 1h2" />
                  <path d="M15 18H9" />
                  <path d="M19 18h2a1 1 0 0 0 1-1v-3.65a1 1 0 0 0-.22-.624l-3.48-4.35A1 1 0 0 0 17.52 8H14" />
                  <circle cx="17" cy="18" r="2" />
                  <circle cx="7" cy="18" r="2" />
                </svg>
              ),
            },
            {
              title: globalReach?.features?.[3]?.title,
              icon: (
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <path d="M3 18v-6a9 9 0 0 1 18 0v6" />
                  <path d="M21 19a2 2 0 0 1-2 2h-1a2 2 0 0 1-2-2v-3a2 2 0 0 1 2-2h3zM3 19a2 2 0 0 0 2 2h1a2 2 0 0 0 2-2v-3a2 2 0 0 0-2-2H3z" />
                </svg>
              ),
            },
          ].map((item, i) => (
            <div
              key={i}
              style={{
                background: "#fff",
                borderRadius: 16,
                padding: "20px",
                display: "flex",
                alignItems: "center",
                gap: 14,
                border: "1px solid #e6edf7",
                boxShadow: "0 4px 14px rgba(0,0,0,0.04)",
                transition: "all 0.3s ease",
                cursor: "pointer",
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = "translateY(-4px)";
                e.currentTarget.style.boxShadow =
                  "0 10px 30px rgba(0,0,0,0.1)";
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = "translateY(0)";
                e.currentTarget.style.boxShadow =
                  "0 4px 14px rgba(0,0,0,0.04)";
              }}
            >
              <div
                style={{
                  width: 44,
                  height: 44,
                  background: "#eef2f8",
                  color: "#B16116",
                  borderRadius: 12,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  flexShrink: 0,
                }}
              >
                {item.icon}
              </div>
              <div
                style={{
                  fontSize: 13,
                  color: "#1a3c6e",
                  fontWeight: 600,
                  lineHeight: 1.4,
                }}
              >
                {item.title}
              </div>
            </div>
          ))}
        </div>
      </section>

      {/* PARTNER WITH GLS — centered layout v2 */}
      <section
        className="partner-cta-section"
        style={{
          background: "linear-gradient(120deg, #0a1f4e 0%, #1a3c8e 100%)",
          padding: "70px 80px",
        }}
      >
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            textAlign: "center",
            gap: 20,
          }}
        >
          {/* Heading */}
          <h2
            style={{
              color: "#fff",
              fontSize: 52,
              fontWeight: 800,
              margin: 0,
              lineHeight: 1.15,
              textAlign: "center",
            }}
          >
            {partnerCTA?.title}
          </h2>

          {/* Description */}
          <p
            style={{
              color: "rgba(255,255,255,0.78)",
              fontSize: 17,
              margin: 0,
              textAlign: "center",
              lineHeight: 1.7,
              maxWidth: 560,
            }}
          >
            {partnerCTA?.description}
          </p>

          {/* Button */}
          <button
            onClick={() =>
              navigate(convertCmsUrl(partnerCTA?.button?.link))
            }
            style={{
              background: "#B16116",
              color: "#fff",
              border: "none",
              borderRadius: 8,
              padding: "14px 36px",
              fontWeight: 700,
              fontSize: 15,
              cursor: "pointer",
              whiteSpace: "nowrap",
              marginTop: 8,
            }}
          >
            {partnerCTA?.button?.text}
          </button>

          {/* Links */}
          <div
            className="partner-cta-links"
            style={{
              display: "flex",
              gap: 28,
              justifyContent: "center",
              flexWrap: "wrap",
            }}
          >
            {partnerCTA?.links?.map((link, i) => (
              <a
                key={i}
                href={convertCmsUrl(link.url)}
                style={{
                  color: "rgba(255,255,255,0.6)",
                  fontSize: 13,
                  textDecoration: "none",
                  whiteSpace: "nowrap",
                }}
                onMouseEnter={(e) => e.currentTarget.style.color = "#fff"}
                onMouseLeave={(e) => e.currentTarget.style.color = "rgba(255,255,255,0.6)"}
              >
                {link.title}
              </a>
            ))}
          </div>
        </div>
      </section>

      <SharedFooter />
    </div>
    </>
  );
};

export default GLSPharma;
